import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=e57d3b26&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=e57d3b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57d3b26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e57d3b26')) {
      api.createRecord('e57d3b26', component.options)
    } else {
      api.reload('e57d3b26', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=e57d3b26&scoped=true&", function () {
      api.rerender('e57d3b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8tgay1QcTqvDF/JS/comp/CookieBox.vue"
export default component.exports